
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64.437 36.744"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1065"}},[_c('g',{attrs:{"data-name":"Group 1064"}},[_c('path',{attrs:{"data-name":"Rectangle 493","fill":"#474747","d":"M0 0h43.972v24.732H0z"}})])]),_c('g',{attrs:{"data-name":"Group 1067"}},[_c('g',{attrs:{"data-name":"Group 1066"}},[_c('path',{attrs:{"data-name":"Path 7153","d":"M64.437 17.687l-4.52-10.109H45.943v19.018H5.308v4.324h4.521a5.142 5.142 0 00-.061.751 5.034 5.034 0 1010.067 0 5.143 5.143 0 00-.061-.751h5.083a5.142 5.142 0 00-.061.751 5.034 5.034 0 1010.067 0 5.142 5.142 0 00-.061-.751h12.131a5.142 5.142 0 00-.061.751 5.034 5.034 0 1010.067 0 5.144 5.144 0 00-.061-.751h7.56zm-49.64 15.97a1.988 1.988 0 111.97-1.986 1.978 1.978 0 01-1.97 1.986zm15.027 0a1.987 1.987 0 111.973-1.986 1.978 1.978 0 01-1.969 1.986zm22.076 0a1.987 1.987 0 111.97-1.986 1.978 1.978 0 01-1.966 1.986zm-2.63-16.161a.137.137 0 01-.137-.137v-6.83a.137.137 0 01.137-.137h8.6a.456.456 0 01.418.274l2.984 6.83z","fill":"#474747"}})])])])
          )
        }
      }
    